var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-20",attrs:{"id":"content","role":"main"}},[(_vm.isLogin)?_c('Member'):_c('Public')],1)}
var staticRenderFns = []

export { render, staticRenderFns }